import * as Yup from "yup";

const SubCategoryCreationSchema = Yup.object({
  name: Yup.string().required("name is required"),
  category: Yup.string().required("category is required"),
  code: Yup.string().required("Code is required"),
});
export default SubCategoryCreationSchema;
